import React from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/modal.js';
import { hideLayoutToast } from '../../actions/webMetaData';

class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.timer;
  }

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.props.hideLayoutToast();
    }, 5 * 1000);
  }

  render() {
    let {
      closeButton = true,
      metaData: { layoutModal: { showToast = false, toastContent = '' } } = {}
    } = this.props;
    let closeBtnNode = null;
    if (closeButton) {
      closeBtnNode = (
        <div
          className="ic-close-quickview"
          onClick={() => {
            clearTimeout(this.timer);
            this.props.hideLayoutToast();
          }}
        />
      );
    }
    return (
      <div className="toast" role="alert">
        {closeBtnNode}
        <div className="toast-header">Welcome to</div>
        <div className="toast-body">{toastContent}</div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { metaData = {} } = state;
  return {
    metaData
  };
};

function mapDispatchToProps(dispatch) {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    },
    hideLayoutToast: (name = '') => {
      dispatch(hideLayoutToast(name));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Toast);
